import { render, staticRenderFns } from "./AbsoluteDiscount.vue?vue&type=template&id=8fd5c5e4&scoped=true"
import script from "./AbsoluteDiscount.vue?vue&type=script&lang=js"
export * from "./AbsoluteDiscount.vue?vue&type=script&lang=js"
import style0 from "./AbsoluteDiscount.vue?vue&type=style&index=0&id=8fd5c5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd5c5e4",
  null
  
)

export default component.exports